<template>
    <div id="BlockTitle">
        <div class="block-title-container">
            <input :placeholder="$t('chatbotv2.typeBlockTitle')" v-model="blockName" />
        </div>
    </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
    name: "BlockTitle",
    props: ["name", "storyId", "storyVersion", "block", "isSave"],
    data() {
        return {
            blockName: this.name,
        };
    },
    methods: {
        ...mapActions({
            updateBlock: "CB/updateBlock",
        }),
        updateName() {
            this.updateBlock({
                id: this.storyId,
                version: this.storyVersion,
                blockId: this.block.id,
                payload: {
                    name: this.blockName.trim(),
                },
            });
        },
    },
    beforeDestroy() {
        if (this.isSave && this.name != this.blockName) {
            this.updateName();
        }
    },
};
</script>

<style lang="scss">
#BlockTitle {
    .block-title-container {
        input {
            border: 0;
            font-size: 22px;
            font-weight: 600;
            line-height: 28px;
            width: 100%;
            font-family: Source Sans Pro, sans-serif;
        }
    }
}
</style>
